import api from '../base'

// 获取模板分类
export function getTempType(libId) {
  return api.get('/api/project_lib/search/scene_type_desc/')
}

// 获取模板列表
export function getTempList(params) {
  return api.get('/api/home_page/projectlib/', { params })
}

// 获取页面数据信息
export function getHomePageConfig() {
  return api.get('/api/home_page/config/')
}

// 获取验证码
export function httpPostNormalVcodeSend(data) {
  return api.post('/api/sms/normal-vcode/send/', data)
}

// SEM 广告接口保存
export function httpPostSEMCreate(data) {
  return api.post('/api/cms_pay_clue/sem/create/', data)
}
// 获取是不是填写过信息
export function httpHadSemSubmit() {
  return api.get('/api/cms_pay_clue/sem/has-post/')
}

// 获取知网签名
export function httpPostCnkiSign(data) {
  return api.post('/api/member/thirdpart/cnki/sign', data)
}

// 通过知网信息登录
export function httpPostCnkiLogin(data) {
  return api.post('/api/member/thirdpart/cnki/login', data)
}
